import { css } from "lit";

export const styles = css`
  .upcoming-banner {
    display: flex;
    background: var(--sds-color-background-default-tertiary);
    border-radius: var(--sds-size-radius-400);
    overflow: hidden;
  }

  .upcoming-banner-thumbnail {
    display: block;
    width: 280px;
    min-height: 160px;
    flex-shrink: 0;
    object-fit: cover;
    cursor: pointer;
  }

  .upcoming-banner-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: var(--sds-size-space-400);
    padding: var(--sds-size-space-600);
    flex: 1;
    min-width: 0;
  }

  .upcoming-banner-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: var(--sds-size-space-300);
  }

  .upcoming-banner-header h3 {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-04) var(--sds-typography-family-title);
    margin: 0;
    color: var(--sds-color-text-default-primary);
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  .upcoming-banner-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--sds-size-space-400);
  }

  .upcoming-banner-info {
    display: flex;
    align-items: center;
  }

  .upcoming-banner-info > :not(:first-child)::before,
  .upcoming-banner-date-meta > :not(:first-child)::before {
    content: "";
    display: inline-block;
    vertical-align: middle;
    width: 1px;
    height: 16px;
    background: var(--sds-color-border-default-secondary);
    margin-left: var(--sds-size-space-300);
    margin-right: var(--sds-size-space-300);
  }

  .upcoming-banner-date-meta {
    display: flex;
    align-items: center;
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
  }

  .upcoming-banner-stream-actions {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-200);
  }

  .share-menu-item {
    display: none;
  }

  @media (max-width: 1024px) {
    .upcoming-banner-bottom {
      gap: var(--sds-size-space-200);
    }

    .upcoming-banner-info {
      flex-direction: column;
      align-items: flex-start;
      gap: var(--sds-size-space-200);
    }

    .upcoming-banner-info > :not(:first-child)::before {
      display: none;
    }

    .upcoming-banner-thumbnail {
      width: 250px;
      min-height: auto;
    }
  }

  @media (max-width: 900px) {
    .upcoming-banner {
      flex-direction: column;
    }

    .upcoming-banner-content {
      gap: var(--sds-size-space-800);
    }

    .upcoming-banner-thumbnail {
      width: 100%;
      min-height: auto;
      aspect-ratio: 27 / 14;
    }

    .upcoming-banner-header {
      flex-direction: column;
      align-items: flex-start;
    }

    .upcoming-banner-bottom {
      flex-direction: column;
      align-items: flex-start;
      gap: var(--sds-size-space-800);
    }

    .upcoming-banner-info {
      flex-direction: column;
      align-items: flex-start;
      gap: var(--sds-size-space-400);
    }

    .upcoming-banner-date-meta {
      flex-wrap: wrap;
    }

    .share-button-standalone {
      display: none;
    }

    .share-menu-item {
      display: block;
    }

    .upcoming-banner-stream-actions {
      width: 100%;
      gap: var(--sds-size-space-400);
    }

    .upcoming-banner-stream-actions > wow-button:first-child {
      flex: 1;
      --wow-button-width: 100%;
      --wow-button-inner-width: 100%;
    }
  }
`;
